<div class="three-state-toggle-switch-container" *ngIf="componentUUID != undefined">
	<input type="radio" [name]="componentUUID" (input)="changeState(-1)" [id]="componentUUID + '1'" />
	<label [for]="componentUUID + '1'">
		<fa-icon [icon]="icons.faTimes"></fa-icon>
	</label>

	<input type="radio" [name]="componentUUID" (input)="changeState(0)" [disabled]="disableMidState == true" [id]="componentUUID + '2'" />
	<label [for]="componentUUID + '2'">
		<fa-icon [icon]="icons.faSlash"></fa-icon>
	</label>

	<input type="radio" [name]="componentUUID" (input)="changeState(1)" [id]="componentUUID + '3'" />
	<label [for]="componentUUID + '3'">
		<fa-icon [icon]="icons.faCheck"></fa-icon>
	</label>

	<div class="selected" [ngClass]="'s' + setState"></div>
</div>
